// PROP-656: кому разрешено отвечать в чате — ОДИН список на страницу чата и плавающую панель агента.
// Два списка разошлись бы молча: человек видел бы в панели одни режимы, а на странице другие.
// ⚠️ «Каскад» до PROP-363 назывался «Агент»: значение (`ai_agent`) прежнее, переименована только подпись.
export const AI_MODE_OPTIONS = [
  { value: 'off', text: 'Без ИИ' },
  { value: 'ai', text: 'Ассистент' },
  { value: 'ai_agent', text: 'Каскад' },
  { value: 'agent', text: 'Агент' },
]

/** Признак `useAi` для старого бэкенда, который про режимы ещё не знает. */
export function useAiOf(mode) {
  return mode !== 'off'
}

/**
 * Кто отвечает в этом режиме — для индикатора ожидания. «Агент думает» при выбранном
 * «Ассистенте» было бы неправдой: ответит другой участник. В «Каскаде» первым отвечает
 * ассистент, без ИИ — сама платформа.
 */
const WAITING_NAMES = {
  off: 'Cubus', ai: 'Ассистент', ai_agent: 'Ассистент', agent: 'Агент',
}
export function waitingNameOf(mode) {
  return WAITING_NAMES[mode] || 'Агент'
}
